/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
export type TemplateQuotePublishingStatus_QuoteTemplateFragment = { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, hasAnyPublishedVersion: boolean, owningSystemOrganisationId: string, accessType: Types.TemplateAccessType, templateSharing?: { __typename: 'TemplateSharing', id: string, latestSharedVersionNumber: number, sharedPublicly: boolean, subscribedToTemplate?: { __typename: 'TemplateSubscription', subscribedVersionNumber: number, updateAvailable: boolean } | null } | null };

export const TemplateQuotePublishingStatus_QuoteTemplateFragmentDoc = gql`
    fragment TemplateQuotePublishingStatus_QuoteTemplate on QuoteTemplate {
  id
  resolvedAsReadModelVersionNumber
  hasAnyPublishedVersion
  templateSharing {
    id
    latestSharedVersionNumber
    sharedPublicly
    subscribedToTemplate {
      subscribedVersionNumber
      updateAvailable
    }
  }
  owningSystemOrganisationId
  accessType
}
    `;